/**
 * Normaliza o HTML do ReactQuill removendo espaços extras e tags vazias
 * Preserva espaços simples entre palavras, remove apenas espaços múltiplos e tags vazias
 * @param html - String HTML a ser normalizada
 * @returns String HTML normalizada
 */
export function normalizeHtml(html: string): string {
  if (!html || html.trim() === '' || html === '<p><br></p>' || html === '<p></p>') {
    return '';
  }

  // Remove tags vazias como <p></p>, <p><br></p>, etc.
  let normalized = html
    .replace(/<p>\s*<\/p>/gi, '') // Remove parágrafos vazios
    .replace(/<p><br\s*\/?><\/p>/gi, '') // Remove parágrafos com apenas <br>
    .replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '') // Remove parágrafos com <br> e espaços
    .trim();

  // Remove espaços entre tags HTML (mas preserva espaços dentro do conteúdo)
  normalized = normalized.replace(/>\s+</g, '><');

  // Remove múltiplas quebras de linha consecutivas (mantém apenas uma)
  normalized = normalized.replace(/(<br\s*\/?>){2,}/gi, '<br>');

  // Processa o conteúdo dentro das tags para remover apenas espaços múltiplos (3+ espaços)
  // Preserva espaços simples entre palavras e espaços no início/fim se forem únicos
  normalized = normalized.replace(/>([^<]+)</g, (match, content) => {
    // Remove apenas múltiplos espaços consecutivos (3 ou mais), mantém espaços simples e duplos
    // Preserva espaços no início e fim se forem únicos ou duplos
    let normalizedContent = content.replace(/[ \t]{3,}/g, ' '); // Remove 3 ou mais espaços consecutivos
    
    return normalizedContent ? `>${normalizedContent}<` : match;
  });

  // Remove espaços extras entre tags que possam ter ficado após o processamento
  normalized = normalized.replace(/>\s+</g, '><');

  // Remove parágrafos vazios que possam ter sido criados após a normalização
  normalized = normalized.replace(/<p>\s*<\/p>/gi, '');
  normalized = normalized.replace(/<p><br\s*\/?><\/p>/gi, '');

  // Se após a normalização ficar vazio, retorna string vazia
  if (normalized === '' || normalized === '<p></p>' || normalized === '<p><br></p>' || normalized.trim() === '') {
    return '';
  }

  return normalized.trim();
}

